import { TextField } from "./ui";
import { isEmpty } from "lodash";
import React, { useState } from "react";

const Popup = () => {
    const [status, setStatus] = useState("");
    const [pdfUrl, setPdfUrl] = useState("");
    const [tcpPort, setTcpPort] = useState("");
    const [extensioId, setExtensionId] = useState("");


    const handlePrint = () => {
        //const pdfUrl = "https://ecartdev.snpnextgen.com:8083/files/pdf/2/FY25Bill-21829.pdf"; // Can be dynamic
        setStatus("");
        if (isEmpty(extensioId)) {
            alert("Extension id cannot be empty");
            return;
        }
        if (isEmpty(pdfUrl)) {
            alert("Pdf url cannot be empty");
            return;
        }
        console.log("handlePrint",extensioId,pdfUrl);
        window.chrome.runtime.sendMessage(extensioId, { type: "SNP_PRINT_PDF", pdfUrl }, (response) => {
            console.log('Print status:', response, window.chrome.runtime.lastError?.message);
            setStatus("Res: " + (JSON.stringify(response)) + " error: " + window.chrome?.runtime?.lastError?.message);
        });
    };

    const handleListPrinter = () => {
        setStatus("");
        if (isEmpty(extensioId)) {
            alert("Extension id cannot be empty");
            return;
        }
        console.log("handleListPrinter",extensioId);
        window.chrome.runtime.sendMessage(extensioId, { type: "LIST_PRINTERS" }, (response) => {
            console.log('Print status:', response, window.chrome.runtime.lastError?.message);
            setStatus("Res: " + (JSON.stringify(response)) + " error: " + window.chrome?.runtime?.lastError?.message);
        });
    };

    const handleSampleUsb = () => {
        setStatus("");
        window.chrome.runtime.sendMessage(extensioId, { type: "SNP_PRINT_USB" }, (response) => {
            console.log('Print status:', response, window.chrome.runtime.lastError?.message);
            setStatus("Res: " + (JSON.stringify(response)) + " error: " + window.chrome?.runtime?.lastError?.message);
        });
    };

    const handleUsbStatus = () => {
        setStatus("");
        window.chrome.runtime.sendMessage(extensioId, { type: "USB_STATUS" }, (response) => {
            console.log('Print status:', response, window.chrome.runtime.lastError?.message);
            setStatus("Res: " + (JSON.stringify(response)) + " error: " + window.chrome?.runtime?.lastError?.message);
        });
    };

     const handleTcpStatus = () => {
        setStatus("");
        if (isEmpty(extensioId)) {
            alert("Extension id cannot be empty");
            return;
        }
        if (isEmpty(tcpPort)) {
            alert("tcp cannot be empty");
            return;
        }
        const tcp = tcpPort.split(";")[0];
        const port = tcpPort.split(";")[1];
        window.chrome.runtime.sendMessage(extensioId, { type: "TCP_STATUS",tcp:tcp,port:port }, (response) => {
            console.log('Print status:', response, window.chrome.runtime.lastError?.message);
            setStatus("Res: " + (JSON.stringify(response)) + " error: " + window.chrome?.runtime?.lastError?.message);
        });
    };

     const handleTcpPrint = () => {
        setStatus("");
        if (isEmpty(extensioId)) {
            alert("Extension id cannot be empty");
            return;
        }
        if (isEmpty(tcpPort)) {
            alert("tcp cannot be empty");
            return;
        }
        const tcp = tcpPort.split(";")[0];
        const port = tcpPort.split(";")[1];
        window.chrome.runtime.sendMessage(extensioId, { type: "SNP_PRINT_TCP",tcp:tcp,port:port }, (response) => {
            console.log('Print status:', response, window.chrome.runtime.lastError?.message);
            setStatus("Res: " + (JSON.stringify(response)) + " error: " + window.chrome?.runtime?.lastError?.message);
        });
    };

    const handleCheckPrinterStatus = () => {
        setStatus("");
        if (isEmpty(extensioId)) {
            alert("Extension id cannot be empty");
            return;
        }
        console.log("handleCheckPrinterStatus",extensioId);
        window.chrome.runtime.sendMessage(extensioId, { type: "CHECK_PRINTER_STATUS" }, (response) => {
            console.log('Print status:', response, window.chrome.runtime.lastError?.message);
            setStatus("Res: " + (JSON.stringify(response)) + " error: " + window.chrome?.runtime?.lastError?.message);
        });
    };


    return (
        <div style={{ padding: "10px", fontFamily: "sans-serif",display:"grid",margin:"20px" }}>
            <h2>Silent PDF Printer</h2>
            <TextField
                required
                id="ext-Name"
                label="Enter Extension From chrome"
                name="ext-Name"
                value={extensioId}
                onChange={(e) => setExtensionId(e.target.value)}
            />
            <button onClick={handleUsbStatus}>Usb Status</button>
            <button onClick={handleSampleUsb}>Sample Usb</button>
            <TextField
                required
                id="tcp"
                label="Enter Tcp Port"
                name="tcp"
                value={tcpPort}
                onChange={(e) => setTcpPort(e.target.value)}
            />
            <button onClick={handleTcpStatus}>Tcp Status</button>
            <button onClick={handleTcpPrint}>Sample Tcp</button>
            
            <TextField
                required
                id="pdf-Name"
                label="Enter Pdf Url"
                name="pdf-Name"
                value={pdfUrl}
                onChange={(e) => setPdfUrl(e.target.value)}
            />
            <button onClick={handlePrint}>Print PDF</button>
            <p>{status}</p>
        </div>
    );
};

export default Popup;
